import React from 'react';
import './yubiKeyModal.scss';

const YubiKeyModal = ({ isOpen, onClose, onSubmit, onDevSkip, yubiKey, setYubiKey, error }) => {
  if (!isOpen) return null;

  return (
    <div className="yubikey-modal-overlay">
      <div className="yubikey-modal">
        <div className="yubikey-modal-content">
          <h2>Security Verification</h2>
          <p className="yubikey-instruction">Please insert your Ladder Access Card</p>
          <input
            type="password"
            placeholder="YubiKey Input"
            value={yubiKey}
            onChange={(e) => setYubiKey(e.target.value)}
            className="yubikey-input"
            autoFocus
          />
          {error && <span className="error-message">{error}</span>}
          <div className="yubikey-modal-buttons">
            <button onClick={onClose} className="cancel-button">Cancel</button>
            <button onClick={onSubmit} className="submit-button">Verify</button>
          </div>
          
          {/* Bypass button (always available) */}
          <div className="dev-tools">
            <button 
              onClick={onDevSkip} 
              className="skip-button"
              title="Bypass YubiKey verification"
            >
              Bypass
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YubiKeyModal;
